// extracted by mini-css-extract-plugin
module.exports = {"MdTitle":"BasicInfo_MdTitle__LU_3v"};